export type SavedArtworkPageModel = {
  agency_id: number,
  cache_key: number,
  data?: any,
  id: number,
  title: string,
  type: string,
  user_id: number,
}

export type SavedArtworkPageRequestOptions = {}

const state = {
  id: null,
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
